<!-- Forms -->
<ui-dialog
    [open]="currentlyOpenDialog === 'CREATE_OFFCYCLE_PAYROLL'"
    [form]="createPayrollForm.form"
    size="small"
    header="payroll.run.createOffCyclePayroll"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    (primaryButtonPressed)="onCreate(createPayrollForm)"
    (closing)="currentlyOpenDialog = undefined"
>
    <app-form-payroll-off-cycle #createPayrollForm></app-form-payroll-off-cycle>
</ui-dialog>

<!-- Body -->
<div *ngIf="!isUnderMaintenance" class="ui basic segment" [class.loading]="isLoading">
    <app-header
        *ngIf="payrollModuleMenuService"
        title="payroll.run.runPayroll"
        [menuService]="payrollModuleMenuService"
    >
        <div class="buttons">
            <ui-button type="primary" *ngIf="!isUnderMaintenance" (click)="showOffCyclePayrollModal()">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'payroll.run.createOffCyclePayroll' | translate }}
            </ui-button>
            <app-pagination [total]="paginator.total" [current]="paginator.page" (pageChange)="paginator.page = $event">
            </app-pagination>
        </div>
    </app-header>

    <!--No Payrolls-->
    <div *ngIf="!paginator?.total" class="ui segment empty">
        <img style="max-width: 400px" src="/assets/illustrations/piggy-bank.png" />
        <h2 class="ui centered header">{{ 'payroll.run.noOpenPayroll' | translate }}</h2>
        <ui-button type="primary" (click)="showOffCyclePayrollModal()">{{
            'payroll.run.createOffCyclePayroll' | translate
        }}</ui-button>
    </div>

    <div class="ui table segment" *ngIf="paginator?.total">
        <table class="ui selectable unstackable table">
            <thead>
                <tr>
                    <th>{{ 'payroll.run.period' | translate }}</th>
                    <th>{{ 'payroll.run.periodSpans' | translate }}</th>
                    <th>{{ 'payroll.run.payDay' | translate }}</th>
                    <th>{{ 'payroll.run.runBy' | translate }}</th>
                    <th>{{ 'payroll.run.type' | translate }}</th>
                    <th class="right aligned">{{ 'payroll.run.state' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let payroll of paginator.values" [routerLink]="[payroll.id]">
                    <td>
                        {{
                            'payroll.run.of'
                                | translate: { periodNo: payroll.periodNo, totalPeriods: payroll.totalPeriods }
                        }}
                    </td>
                    <td>{{ payroll.startDate | i18nDate: 'long' }} - {{ payroll.endDate | i18nDate: 'long' }}</td>
                    <td>{{ payroll.chequeDate | i18nDate: 'long' }}</td>
                    <td>{{ payroll.deadline | i18nDate: 'long' }}</td>
                    <td class="collapsing right aligned">
                        <ui-badge>{{
                            (payroll.recurring ? 'payroll.run.recurring' : 'payroll.run.offCycle') | translate
                        }}</ui-badge>
                    </td>
                    <td class="collapsing right aligned">
                        <ui-badge *ngIf="payroll.late" type="danger">{{ 'payroll.run.late' | translate }} </ui-badge>
                        <ui-badge [type]="BADGE_TYPES[payroll.state] || 'default'">
                            {{ payroll.state | translate }}
                        </ui-badge>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div *ngIf="isUnderMaintenance" class="ui basic login segment">
    <div class="container">
        <div class="ui raised segment" style="text-align: center">
            <div [innerHTML]="'payroll.run.scheduledMaintenanceNotice' | translate"></div>
            <ui-button type="link" [externalLink]="true" url="https://status.humi.ca">{{
                'payroll.run.viewStatus' | translate
            }}</ui-button>
        </div>
    </div>
</div>
